import { createUseStyles } from '@glu/theming';

const styles = ({ palette: { grey }, spacing: { unit } }) => ({
  defaultButton: {
    marginTop: unit * 3
  },
  extensionLabel: { display: 'flex', justifyContent: 'space-between', marginTop: `${unit / 2}px` },
  extensionOpt: { color: grey.G600 },
  extensionTitle: { color: grey.G600, textTransform: 'uppercase' }
});

export default createUseStyles(styles);
